(()=>{
'use strict';
const $=(s,r=document)=>r.querySelector(s);
const $$=(s,r=document)=>Array.from(r.querySelectorAll(s));
const parse=h=>new DOMParser().parseFromString(h,'text/html');
let tt;
function toast(m){let t=$('#Toast');if(!t){t=document.createElement('div');t.id='Toast';t.className='toast';t.setAttribute('role','status');document.body.appendChild(t)}t.textContent=m;t.classList.add('is-on');clearTimeout(tt);tt=setTimeout(()=>t.classList.remove('is-on'),3600)}
function show(el){if(!el)return;el.hidden=false;requestAnimationFrame(()=>el.classList.add('is-open'));document.body.classList.add('no-scroll')}
function hide(el){if(!el)return;el.classList.remove('is-open');setTimeout(()=>{el.hidden=true},200);if(!$('.drawer.is-open,.mdrawer.is-open'))document.body.classList.remove('no-scroll')}

/* carrello */
const pageSec=()=>{const e=$('[data-cart-page]');return e?e.dataset.sectionId:''};
function apply(s){
  if(!s)return;
  if(s['cart-drawer']){const n=$('#CartDrawerBody',parse(s['cart-drawer'])),o=$('#CartDrawerBody');if(n&&o)o.innerHTML=n.innerHTML}
  const ps=pageSec();
  if(ps&&s[ps]){const n=$('[data-cart-page]',parse(s[ps])),o=$('[data-cart-page]');if(n&&o)o.innerHTML=n.innerHTML}
  const c=$('[data-cart-count-src]');const n=c?Number(c.dataset.cartCountSrc):0;
  $$('[data-cart-count]').forEach(e=>{e.textContent=n;e.hidden=!n});
}
async function cartReq(url,body){
  const ps=pageSec();
  body.sections=['cart-drawer'].concat(ps?[ps]:[]).join(',');
  body.sections_url=location.pathname;
  const r=await fetch(url,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
  const j=await r.json();
  if(!r.ok||j.status){throw new Error(j.description||j.message||'Operazione non riuscita')}
  apply(j.sections);return j;
}
async function changeLine(line,q){try{await cartReq('/cart/change.js',{line:Number(line),quantity:Math.max(0,q)})}catch(e){toast(e.message)}}

document.addEventListener('submit',async e=>{
  const f=e.target.closest('form[data-ajax="add"]');if(!f)return;
  e.preventDefault();
  const b=$('[type=submit]',f);if(b){b.disabled=true;b.classList.add('is-loading')}
  try{const fd=new FormData(f);await cartReq('/cart/add.js',{id:Number(fd.get('id')),quantity:Number(fd.get('quantity')||1)});show($('#CartDrawer'))}
  catch(err){toast(err.message)}
  finally{if(b){b.disabled=false;b.classList.remove('is-loading')}}
});

document.addEventListener('click',e=>{
  const t=e.target,c=s=>t.closest(s);let el;
  if(c('[data-open-cart]')){if($('#CartDrawer')&&!$('[data-cart-page]')){e.preventDefault();show($('#CartDrawer'))}return}
  if((el=c('[data-close-drawer]'))){hide(el.closest('.drawer'));return}
  if(c('[data-open-menu]')){show($('#MobileMenu'));return}
  if(c('[data-close-menu]')){hide($('#MobileMenu'));return}
  if((el=c('.qty[data-line] [data-qty]'))){const w=el.closest('.qty'),i=$('[data-qty-input]',w);changeLine(w.dataset.line,(Number(i.value)||0)+Number(el.dataset.qty));return}
  if((el=c('[data-remove]'))){changeLine(el.dataset.line,0);return}
  if((el=c('[data-copy]'))){navigator.clipboard&&navigator.clipboard.writeText(el.dataset.copy).then(()=>toast('Codice copiato: '+el.dataset.copy));return}
});
document.addEventListener('change',e=>{const i=e.target.closest('[data-qty-input]');if(i)changeLine(i.closest('.qty').dataset.line,Number(i.value)||0)});
document.addEventListener('keydown',e=>{if(e.key==='Escape'){$$('.drawer.is-open,.mdrawer.is-open').forEach(hide)}});

/* menu a tendina categorie */
$$('[data-mega]').forEach(m=>{
  const btn=$('[data-mega-toggle]',m),panel=$('.mega__panel',m);let t;
  const open=()=>{clearTimeout(t);panel.hidden=false;btn.setAttribute('aria-expanded','true')};
  const shut=()=>{panel.hidden=true;btn.setAttribute('aria-expanded','false')};
  btn.addEventListener('click',()=>panel.hidden?open():shut());
  m.addEventListener('mouseenter',()=>{if(matchMedia('(hover:hover)').matches)open()});
  m.addEventListener('mouseleave',()=>{t=setTimeout(shut,140)});
  $$('[data-dept]',m).forEach(a=>{const act=()=>{$$('[data-dept]',m).forEach(x=>x.classList.toggle('is-on',x===a));$$('[data-group]',m).forEach(g=>{g.hidden=g.dataset.group!==a.dataset.dept})};a.addEventListener('mouseenter',act);a.addEventListener('focus',act)});
  const first=$('[data-dept]',m);if(first)first.dispatchEvent(new Event('mouseenter'));
  document.addEventListener('click',e=>{if(!m.contains(e.target))shut()});
});

/* ricerca con suggerimenti */
$$('[data-search]').forEach(form=>{
  const input=$('input[name=q]',form),box=$('[data-sr]',form);if(!input||!box)return;
  let timer,ctl;const close=()=>{box.hidden=true};
  input.addEventListener('input',()=>{
    clearTimeout(timer);const q=input.value.trim();if(q.length<2){close();return}
    timer=setTimeout(async()=>{
      if(ctl)ctl.abort();ctl=new AbortController();
      try{const r=await fetch('/search/suggest?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.sku,vendor&section_id=predictive-search',{signal:ctl.signal});
        const n=$('.sr-inner',parse(await r.text()));box.innerHTML=n?n.innerHTML:'';box.hidden=!box.innerHTML.trim()}catch(_){}
    },180);
  });
  document.addEventListener('click',e=>{if(!form.contains(e.target))close()});
  input.addEventListener('keydown',e=>{if(e.key==='Escape')close()});
});

/* scheda prodotto */
function initProduct(root){
  const vs=$('[data-variants]',root);if(!vs)return;
  const data=JSON.parse(vs.textContent);if(!data.length)return;
  const idIn=$('[data-variant-id]',root),btn=$('[data-add]',root),row=$('[data-buyrow]',root),price=$('[data-price]',root),sku=$('[data-sku]',root),av=$('[data-avail]',root),qb=$('[data-quote]',root),ql=$('[data-quote-link]',root),pack=$('[data-pack]',root),main=$('[data-main-img]',root),sp=$('[data-sticky-price]');
  const cur=()=>{const els=$$('[data-option]',root);if(!els.length||data.length===1)return data[0];const vals=[];els.forEach(el=>{const i=Number(el.dataset.index);if(el.type==='radio'){if(el.checked)vals[i]=el.value}else vals[i]=el.value});return data.find(v=>v.options.every((o,i)=>o===vals[i]))};
  function upd(){
    const v=cur();
    if(!v){if(btn)btn.disabled=true;if(av){av.textContent='Combinazione non disponibile';av.className='avail avail--no'}return}
    if(idIn)idIn.value=v.id;
    if(price)price.innerHTML=(v.compare&&v.compare>v.price?'<s class="muted">'+v.compare_fmt+'</s> ':'')+'<strong>'+v.price_fmt+'</strong>'+(v.compare&&v.compare>v.price?' <span class="badge badge--sale">Offerta</span>':'');
    if(sku)sku.textContent=v.sku?'Cod. '+v.sku:'';
    if(av){av.textContent=v.available?'Disponibile':'Non disponibile';av.className='avail '+(v.available?'avail--yes':'avail--no')}
    if(btn){btn.disabled=!v.available;btn.textContent=v.available?(btn.dataset.label||'Aggiungi al carrello'):'Non disponibile'}
    if(row)row.hidden=!!v.quote;
    if(qb){qb.hidden=!v.quote;if(ql){const q=($('[name=quantity]',root)||{}).value||'1';ql.href=ql.dataset.base+'?item='+encodeURIComponent((v.sku?v.sku+' — ':'')+root.dataset.title+(v.title&&v.title!=='Default Title'?' — '+v.title:''))+'&quantity='+encodeURIComponent(q)}}
    if(pack){pack.textContent=v.pack||'';pack.hidden=!v.pack}
    if(v.img&&main){main.src=v.img;main.removeAttribute('srcset')}
    if(sp)sp.textContent=v.price_fmt;
    if(data.length>1){const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u)}
  }
  root.addEventListener('change',e=>{if(e.target.matches('[data-option]'))upd()});
  root.addEventListener('click',e=>{const b=e.target.closest('[data-pq]');if(!b)return;const i=$('[name=quantity]',root);i.value=Math.max(1,(Number(i.value)||1)+Number(b.dataset.pq));upd()});
  $$('[data-thumb]',root).forEach(t=>t.addEventListener('click',()=>{if(main){main.src=t.dataset.large;main.removeAttribute('srcset')}$$('[data-thumb]',root).forEach(x=>x.classList.toggle('is-on',x===t))}));
  upd();
  const sb=$('.stickybuy'),sa=$('[data-sticky-add]');
  if(sb&&btn&&'IntersectionObserver' in window){new IntersectionObserver(([en])=>sb.classList.toggle('is-on',!en.isIntersecting&&en.boundingClientRect.top<0)).observe(btn)}
  if(sa&&btn)sa.addEventListener('click',()=>{if(btn.form)btn.form.requestSubmit()});
}
$$('[data-product]').forEach(initProduct);

/* correlati */
$$('[data-recommendations]').forEach(async el=>{try{const r=await fetch(el.dataset.url);const n=$('[data-recommendations]',parse(await r.text()));if(n&&n.innerHTML.trim())el.innerHTML=n.innerHTML}catch(_){}});

/* filtri catalogo */
$$('[data-filter-form]').forEach(f=>f.addEventListener('change',()=>f.requestSubmit()));
const ft=$('[data-filters-toggle]'),fp=$('[data-filters-panel]');
if(ft&&fp){ft.addEventListener('click',()=>{fp.classList.toggle('is-open');document.body.classList.toggle('no-scroll',fp.classList.contains('is-open'))});$$('[data-filters-close]').forEach(b=>b.addEventListener('click',()=>{fp.classList.remove('is-open');document.body.classList.remove('no-scroll')}))}

/* preventivo: precompila articolo */
const qi=$('#QuoteItems');
if(qi){const p=new URLSearchParams(location.search),it=p.get('item');if(it&&it.length<=1000){const q=Math.max(1,Math.min(100000,Number(p.get('quantity'))||1));qi.value=(it+' × '+q+'\n'+qi.value).trim()}}
})();